import { useTranslation } from "react-i18next";
import {
  capsuleBandsForTargetGroups,
  getWhoBandMeta,
} from "../constants/whoPhysicalActivityByAge";
import { useBrand } from "../context/BrandContext";
import "./ScforhWhoCapsule.css";

/**
 * Compact WHO / SCforH learning capsule: activity rec + key benefits for age bands.
 */
export default function ScforhWhoCapsule({
  bands = [],
  targetGroups,
  tone = "auto",
  variant = "compact",
  lng,
} = {}) {
  const { t, i18n } = useTranslation();
  const { themeMode } = useBrand();
  const translate = lng ? i18n.getFixedT(lng) : t;
  const resolvedTone =
    tone === "auto" || tone == null
      ? themeMode === "dark"
        ? "dark"
        : "light"
      : tone;
  const resolved = Array.isArray(bands) && bands.length
    ? bands
    : capsuleBandsForTargetGroups(targetGroups);
  if (!resolved.length) return null;

  return (
    <div className={`who-capsule who-capsule--${variant} who-capsule--${resolvedTone}`}>
      {resolved.map((band) => {
        const meta = getWhoBandMeta(band);
        const benefits = (meta.benefitKeys || []).slice(0, variant === "full" ? 8 : 5);
        return (
          <article key={band} className="who-capsule__card">
            <p className="who-capsule__eyebrow">{translate("whoCapsuleEyebrow")}</p>
            <h4 className="who-capsule__title">{translate(`whoCapsuleTitle_${band}`)}</h4>
            <p className="who-capsule__rec">{translate(meta.recKey)}</p>
            <p className="who-capsule__benefits-label">{translate("whoBenefitsLabel")}</p>
            <ul className="who-capsule__benefits">
              {benefits.map((id) => (
                <li key={id}>{translate(`whoBenefit_${id}`)}</li>
              ))}
            </ul>
          </article>
        );
      })}
    </div>
  );
}
